'use client'

import { deleteAssetsThunk } from "features/assets/model/slice/assetsSlice"
import { deleteBoardsThunk } from "features/boards/model/slice/boardsSlice"
import { BoardToolbarAction } from "shared/constants/toolbar"
import { selectModalContext, selectModalData, selectModalType } from "features/common/model/selectors/modalSelectors"
import { closeModal } from "features/common/model/slice/moadlSlice"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "shared/config/store"

import { ConfirmationModal } from "../ConfirmationModal"


export const DeleteItemModal = () => {
  const dispatch = useAppDispatch()
  const modalType = useAppSelector(selectModalType)
  const modalContext = useAppSelector(selectModalContext)
  const modalData = useAppSelector(selectModalData)
  const navigate = useNavigate()

  const getLinkedNodeIds = () => {
    return modalData?.items?.filter((item) => item.type === 'link')?.map((item) => item.linked_node_id)
  }

  const getLinkedNodesIds = () => {
    const boardsIds = modalData?.items?.filter((item) => item.type === 'dir')?.map((item) => item.id)
    const assetsIds = modalData?.items?.filter((item) => item.type === 'link')?.map((item) => item.id)
    const linkedAssetsNodeIds = getLinkedNodeIds()

    return {
      boardsIds: boardsIds.filter(Boolean) as string[],
      assetsIds: assetsIds.filter(Boolean) as string[],
      linkedAssetsNodeIds: linkedAssetsNodeIds.filter(Boolean) as string[]
    }
  }



  const isSingleItem = modalData?.items?.length === 1

  const getModalTitle = () => {
    if(modalContext === 'mixed') {
      return `Delete selected items`
    } else if(modalContext === 'board') {
      if(isSingleItem) {
        return `Delete board`
      } else {
        return `Delete boards`
      }
    } else if(modalContext === 'asset') {
      if(isSingleItem) {
        return `Delete asset`
      } else {
        return `Delete assets`
      }
    }
  }

  const getModalText = () => {
    if(isSingleItem) {
      return `Are you sure you want to delete "${modalData?.items?.[0]?.name}" from the library?`
    } else {
      if (modalContext === 'board') {
        return `Are you sure you want to delete ${modalData?.items?.length} selected boards from the library?`
      } else if (modalContext === 'asset') {
        return `Are you sure you want to delete ${modalData?.items?.length} selected assets from the library?`
      } else if (modalContext === 'mixed') {
        return `Are you sure you want to delete ${modalData?.items?.length} selected items from the library?`
      }
    }
  }

  const handleCancel = () => {
    dispatch(closeModal())
  }

  const handleConfirm = async () => {
    handleCancel()

    const { boardsIds, linkedAssetsNodeIds } = getLinkedNodesIds() // linked id means id of the original asset
    const modalDataIds = modalData.ids
    const linkedIds = linkedAssetsNodeIds.length > 0 ? linkedAssetsNodeIds : modalDataIds

    const deleteActions = {
      board: async () => {
        await dispatch(deleteBoardsThunk({ ids: modalDataIds }))

        if (modalData?.redirectTo) {
          navigate(modalData?.redirectTo)
        }
      },
      asset: async () => {
        await dispatch(deleteAssetsThunk({ ids: modalDataIds, linkedIds }))
      },
      mixed: async () => {
        await dispatch(deleteBoardsThunk({ ids: boardsIds, needNotify: false }))
        await dispatch(deleteAssetsThunk({ ids: modalDataIds, linkedIds }))
      }
    }

    await deleteActions[modalContext]?.()

    // showNotification({
    //   type: NOTIFICATION_TYPES.SUCCESS,
    //   title: `${modalData?.items?.length} items deleted`,
    //   message: 'Items deleted successfully',
    // })
  }

  return (
    <ConfirmationModal
      open={modalType === BoardToolbarAction.Delete}
      title={getModalTitle()}
      description={getModalText()}
      onCancel={handleCancel}
      onConfirm={handleConfirm}
      confirmText="Delete"
    />
  )
}
